// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CartPoints-module-points-f5gXh{display:flex;flex-direction:column;justify-content:center;align-items:flex-start;background-color:rgba(210,210,210,.25);padding-block:23px 28px;padding-inline:32px;border-radius:8px}@media(min-width: 960px){.CartPoints-module-points-f5gXh{align-items:flex-start}}.CartPoints-module-reward-agLlm{margin-bottom:23px;color:#373a36;font-size:20px;font-weight:var(--weight-light);line-height:33px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"points": "CartPoints-module-points-f5gXh",
	"reward": "CartPoints-module-reward-agLlm"
};
export default ___CSS_LOADER_EXPORT___;
